import React from 'react';

/**
 * Stores and returns the previous value of `value` from the prior render.
 * Returns an empty object on the very first render.
 */
export const usePreviousProps = <T extends object>(value: T): Partial<T> => {
  const ref = React.useRef<Partial<T>>({});
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
